import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Providers ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-2" }, null, -1)
const _hoisted_5 = { class: "w-full grid grid-cols-12 gap-3 px-3 border-[1px] border-grey300 rounded-md" }
const _hoisted_6 = { class: "w-full grid grid-cols-2 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_growth_box = _resolveComponent("roof-growth-box")!
  const _component_roof_growth_graph = _resolveComponent("roof-growth-graph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_roof_growth_box, {
        label: 'Total Providers',
        "growth-data": _ctx.providerOverview?.GetProviderOverview.total_provider
      }, null, 8, ["growth-data"]),
      _createVNode(_component_roof_growth_box, {
        label: 'Accepted Providers',
        "growth-data": _ctx.providerOverview?.GetProviderOverview.accepted_provider
      }, null, 8, ["growth-data"]),
      _createVNode(_component_roof_growth_box, {
        label: 'Pending Providers',
        "growth-data": _ctx.providerOverview?.GetProviderOverview.pending_provider
      }, null, 8, ["growth-data"]),
      _createVNode(_component_roof_growth_box, {
        label: 'Declined Providers',
        "growth-data": _ctx.providerOverview?.GetProviderOverview.declined_provider
      }, null, 8, ["growth-data"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_roof_growth_graph, {
        data: _ctx.providerOverview?.GetProviderGrowth,
        label: 'Providers Growth',
        countLabelPlural: 'providers',
        "count-label-singular": 'provider'
      }, null, 8, ["data"]),
      _createVNode(_component_roof_growth_graph, {
        data: _ctx.providerOverview?.GetActiveProviderGrowth,
        label: 'Active Providers Growth',
        countLabelPlural: 'providers',
        "count-label-singular": 'provider',
        "line-color": "#3DCC79"
      }, null, 8, ["data"])
    ])
  ]))
}